import { performance } from "../constants/actionTypes";

import { concatSimilarArray } from "../helpers";

const defaultState = {
  leadsByWeek: [],
  leadsByYear: [],
  leadsByMonth: [],
  leadsByListing: [],
  leadsByPracticeArea: [],
  error: null,
  preloaders: { leadsByMonth: true, leadsByYear: true, leadsByWeek: true, leadsByListing: true, leadsByPracticeArea: true }
};

const failed = (state, section, error) => ({
  ...state,
  error,
  preloaders: { ...state.preloaders, [section]: false }
});

export default function(state = defaultState, action) {
  switch (action.type) {
    case performance.SET_LOADING:
      return {
        ...state,
        // A new request clears the previous failure so the next one raises a fresh notification.
        error: action.payload.isSectionLoading ? null : state.error,
        preloaders: { ...state.preloaders, [action.payload.section]: action.payload.isSectionLoading }
      };

    case performance.GET_LEADS_BY_MONTH_SUCCESS:
      return {
        ...state,
        leadsByMonth: action.payload,
        preloaders: { ...state.preloaders, leadsByMonth: false }
      };

    case performance.GET_LEADS_BY_YEAR_SUCCESS:
      return {
        ...state,
        leadsByYear: action.payload,
        preloaders: { ...state.preloaders, leadsByYear: false }
      };

    case performance.GET_LEADS_BY_WEEK_SUCCESS:
      return {
        ...state,
        leadsByWeek: action.payload,
        preloaders: { ...state.preloaders, leadsByWeek: false }
      };

    case performance.GET_LEADS_BY_LISTING_SUCCESS:
      return {
        ...state,
        leadsByListing: concatSimilarArray(action.payload),
        preloaders: { ...state.preloaders, leadsByListing: false }
      };

    case performance.GET_LEADS_BY_PRACTICE_AREA_SUCCESS:
      return {
        ...state,
        leadsByPracticeArea: concatSimilarArray(action.payload),
        preloaders: { ...state.preloaders, leadsByPracticeArea: false }
      };

    case performance.GET_LEADS_BY_MONTH_FAIL:
      return failed(state, "leadsByMonth", action.payload);

    case performance.GET_LEADS_BY_YEAR_FAIL:
      return failed(state, "leadsByYear", action.payload);

    case performance.GET_LEADS_BY_WEEK_FAIL:
      return failed(state, "leadsByWeek", action.payload);

    case performance.GET_LEADS_BY_LISTING_FAIL:
      return failed(state, "leadsByListing", action.payload);

    case performance.GET_LEADS_BY_PRACTICE_AREA_FAIL:
      return failed(state, "leadsByPracticeArea", action.payload);

    case performance.GET_ERROR_DATA_FROM_SERVER:
      return {
        ...state,
        error: action.payload,
        preloaders: {
          leadsByMonth: false,
          leadsByYear: false,
          leadsByWeek: false,
          leadsByListing: false,
          leadsByPracticeArea: false
        }
      };

    default:
      return state;
  }
}
